import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bba-international-business',
  templateUrl: './bba-international-business.component.html',
  styleUrls: ['./bba-international-business.component.scss']
})
export class BbaInternationalBusinessComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
